import {Redirect, Route, Switch as RouterSwitch} from 'react-router-dom';

import authenticationService from '../../../services/authentication/AuthenticationService';

import MyDocumentsView from '../../../views/documentsDetails/MyDocumentsView';
import ProjectDetailsView from '../../../views/projectDetails/ProjectDetailsView';
import ProjectCreationFunnel from '../../../views/ProjectCreationFunnel';
import RequestSpecificDocuments from '../../../views/requestSpecificDocuments/RequestSpecificDocuments';
import MyArchiveDocumentsView from '../../../views/myArchiveDocuments/MyArchiveDocumentsView';
import OrganisationDashboard from '../../../components/organisationDashboard';
import Projects from '../../../components/projects';
import Subcontractors from '../../../components/subcontractors';
import SubcontractorDetails from '../../../components/subcontractorDetails';
import Clients from '../../../components/clients';
import ClientDetails from '../../../components/clientDetails';
import OrganisationSettings from '../../../components/OrganisationSettings';
import AccessDenied from '../../../components/accessDenied';
import PageNotFound from '../../../components/pageNotFound';
import SubcontractorRedirection from '../../../components/organisation/SubcontractorRedirection';

import PrivateRoute from '../../PrivateRoute';

const DEFAULT_PAGE = '/dashboard';

const Switch = () => {
  const isExplorer = authenticationService.roles().isExplorer();
  return (
    <RouterSwitch>
      <Redirect
        from="/"
        exact
        to={DEFAULT_PAGE}
      />

      <Route
        exact
        path="/dashboard"
        component={OrganisationDashboard}
      />

      <Route
        exact
        path="/documents"
        component={MyDocumentsView}
      />
      <PrivateRoute
        exact
        path="/documents/archives"
        component={MyArchiveDocumentsView}
        canAccess={!isExplorer}
      />
      <Route
        exact
        path="/documents/:organisationId([0-9]+)/remind"
        component={RequestSpecificDocuments}
      />
      <Redirect
        from="/documents"
        to="/documents"
      />
      <Route
        path="/clients"
        component={Clients}
      />
      <PrivateRoute
        path="/client/:clientId([0-9]+)"
        component={ClientDetails}
        canAccess={!isExplorer}
      />
      <Redirect
        from="/client"
        to="/clients"
      />
      <Route
        exact
        path="/projects"
        component={Projects}
      />
      <Route
        exact
        path="/projects/new"
        component={ProjectCreationFunnel}
      />
      <Route
        path="/project/:projectId([0-9]+)/intervention/:interventionId([0-9]+)"
        component={ProjectDetailsView}
      />
      <Redirect
        from="/project"
        to="/projects"
      />
      <Route
        path="/subcontractors"
        component={Subcontractors}
      />
      <Route
        exact
        path="/subcontractor/:organisationId([0-9]+)/remind"
        component={RequestSpecificDocuments}
      />
      <Route
        exact
        path="/subcontractor/external-id/:country/:registrationNumber"
        component={SubcontractorRedirection}
      />
      <Route
        path="/subcontractor/:subcontractorId([0-9]+)"
        component={SubcontractorDetails}
      />
      <Redirect
        from="/subcontractor"
        to="/subcontractors"
      />
      <Route
        path="/organisation"
        component={OrganisationSettings}
      />

      <Route
        exact
        path="/access-denied"
        component={AccessDenied}
      />
      <Route component={PageNotFound}/>
    </RouterSwitch>
  );
};

export default Switch;
